import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import Button from '../../../../components/Button';
import Table from '../../../../components/Table';
import Header from '../../../../components/Table/Header';
import Cell from '../../../../components/Cell';
import ExportButton from '../../../../components/Export';
import { I18n } from 'react-redux-i18n';

const AverageMarginCardContainer = styled.div`
  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }
  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    width: 200px;
  }
`;

export default class SellerInfoCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverExport: false,
      sorted: [{ id: 'margin', desc: false }],
      showAll: false
    };
  }

  handleSort = (id) => {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted });
  };

  getColumns = () => [
    {
      accessor: 'name',
      Header: () => (
        <Header
          sortable={true}
          sort={() => this.handleSort('name')}
          styles={`justify-content:flex-start;padding-left:30px; .title{font-size:12px}`}
          title={I18n.t('primeur.recap.sellerInfoTable.columns.seller')}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          font="sfcompact_text"
          styles={`justify-content:flex-start;padding-left:30px; font-weight:600;`}
        >
          {props.value}
        </Cell>
      ),
      minWidth: 150
    },
    {
      Header: () => (
        <Header
          sortable={true}
          sort={() => this.handleSort('country')}
          title={I18n.t('primeur.recap.sellerInfoTable.columns.market')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => (
        <Cell
          type={props.value.code ? 'country' : 'text'}
          value={props.value.code ? props.value.code : props.value}
          {...props}
        >
          {props.value}
        </Cell>
      ),

      accessor: 'country'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('primeur.recap.sellerInfoTable.columns.exist')}
          sortable={true}
          sort={() => this.handleSort('presence')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => <Cell {...props}>{props.value}</Cell>,

      accessor: 'presence'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('primeur.recap.sellerInfoTable.columns.diff')}
          sortable={true}
          sort={() => this.handleSort('margin')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          value={
            props.value
              ? (props.value * 100).toLocaleString('fr-FR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                }) + ' %'
              : '0 %'
          }
        />
      ),
      accessor: 'margin'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('primeur.recap.sellerInfoTable.columns.evolution')}
          sortable={true}
          sort={() => this.handleSort('evolution')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => <Cell {...props}>{props.value}</Cell>,
      accessor: 'evolution'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('primeur.recap.sellerInfoTable.columns.nbRival')}
          sortable={true}
          sort={() => this.handleSort('nb_rivals')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => <Cell {...props}>{props.value}</Cell>,

      accessor: 'nb_rivals'
    }
  ];

  formatData() {
    const { data } = this.props || [];
    return data.map((item) => ({
      ...item,
      name: item.store_name ? item.store_name : '',
      presence: item.presence
        ? I18n.t('primeur.recap.sellerInfoTable.yes')
        : I18n.t('primeur.recap.sellerInfoTable.no'),
      country: item.store_market ? item.store_market : ''
    }));
  }

  deleteDoubles(data) {
    let names = [];
    data = data.filter((store) => {
      if (names.includes(store.name)) {
        return false;
      } else {
        names.push(store.name);
        return true;
      }
    });
    return data;
  }

  render() {
    const { retractedSize, wine, vintage } = this.props;
    let formattedData = this.formatData();
    formattedData = this.deleteDoubles(formattedData);
    formattedData.sort((a, b) => (a && b ? a.margin - b.margin : 0));
    const { sorted, showAll } = this.state;

    const subSetData = showAll
      ? formattedData
      : formattedData.slice(0, retractedSize);

    const columns = this.getColumns();
    return (
      <AverageMarginCardContainer>
        <Card id="information-vendeur-recap">
          <CardHeader
            title={I18n.t('primeur.recap.sellerInfoTable.title')}
            fontSize={'20px'}
            iconRight
            rightComponents={
              <ExportButton
                jpg
                pdf
                xls
                path={`/api/v1/clients/me/primeur/recap/xls/?wines=["${
                  wine ? wine.label : ''
                }"]&vintage=${vintage ? vintage.label : ''}`}
                name={`${I18n.t('primeur.recap.sellerInfoTable.title')}${
                  wine ? '-' + wine.label : ''
                }${vintage ? '-' + vintage.label : ''}`}
                targetElement="#information-vendeur-recap"
              />
            }
          />
          <Table
            data={subSetData}
            columns={columns}
            sorted={sorted}
            subRowsKey={null}
          />
          <div className="showAllContainer ignored-export">
            {!showAll && formattedData.length > retractedSize && (
              <Button
                width="200px"
                label={`${I18n.t('seeMore')} (+${
                  formattedData.length - retractedSize
                })`}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: true })}
              />
            )}
            {showAll && formattedData.length > retractedSize && (
              <Button
                width="200px"
                label={I18n.t('seeLess')}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: false })}
              />
            )}
          </div>
        </Card>
      </AverageMarginCardContainer>
    );
  }
}
